
import React, { Suspense } from 'react';
import './App.css';
import routes from './routes/index'
import { Container, Row, Col } from 'react-bootstrap'
import { Header, Footer } from "CommonLibrary"
import Loader from './component/containers/loader/index'
const loadingImg = <Loader loader="true"/>
const App = () => {
  return (
    <div className="App">
      <Suspense fallback={loadingImg}>
        <Container fluid>
        
          <Row>
            <Header name="Customer Service Web Portal" />
          </Row>
          <Row>
            <Col>
                {routes}
            </Col>
          </Row>
          <Row>
              <Footer />
          </Row>
        </Container>
      </Suspense>
    </div>
  );
}

export default App;
